import type { Filters as ContractFilters } from '@firmable/contracts';

export const MAX_FAVOURITES = 10;

export type FavouriteFilterId = ContractFilters.Identifiers;

export type FavouritesState = {
  ids: FavouriteFilterId[];
};

export type FavouritesActions = {
  add: (id: FavouriteFilterId) => void;
  remove: (id: FavouriteFilterId) => void;
  toggle: (id: FavouriteFilterId) => void;
  isFavourite: (id: FavouriteFilterId) => boolean;
  isAtCap: () => boolean;
  reset: () => void;
};
